import React from "react"
import ReactDOM from "react-dom"
import MerchantQuickAccessImageLinks from "./merchant-quick-access-image-links"

export default class MerchantQuickAccessImageLinksModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantQuickAccessImageLinks {...self.modelJson} />, self.elem)
  }
}
